import {useEffect, useState} from "react";
import {Box, IconButton} from "@mui/material";
import { styled } from "@mui/material/styles";
import HeaderUserbox from "./Userbox";
import LogoButton from "../../../components/LogoButton";
import HeaderSearchTextField from "./HeaderSearchTextField";
import MainMenu from "../../../components/MainMenu";
import {useNotifyer} from "../../../hooks/useNotifyer";
import {gql, useMutation, useSubscription} from "@apollo/client";
import {useAppState} from "../../../hooks/useAppState";
import {useKeycloak} from "../../../src/useKeycloak";
import NotificationBell from "../../../components/Notification/NotificationBell";
import UserLookUpComponent from "../../../components/UserLookUpComponent";

import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faHome} from "@fortawesome/pro-solid-svg-icons";
import {useRouter} from "next/router";

const UPDATE_LASTSEEN_MUTATION = gql`
  mutation updateLastSeen($userId: uuid = "", $lastSeen: timestamp = "") {
    updateUser(_set: { lastSeen: $lastSeen }, pkColumns: { id: $userId }) {
      id
    }
  }
`;

const PERSONAL_DATA = gql`
	subscription myPersonalData($id: uuid = "") {
		user(id: $id) {
			organizationRequests {
				id
				firstName
				lastName
				organizationName
				extraData
			}
			organizationUserInvitations {
				id
				firstName
				lastName
				extraData
				organizationName
			}
			orderIntegrations {
				id
				requestStatus
				lastName
				firstName
				type
				licenses
				deliveryDate
			}
			organizations {
				id
				name
				ownerId
			}
			phoneState
			states {
				type
				value
				queueItem {
					id
					createdAt
					domainActivity {
						id
						endedAt
						requestEndedAt
					}
				}
				queueItemId
				domainUser {
					id
					firstName
					lastName
				}
			}
			userFeed(orderBy: { updatedAt: DESC }) {
				id
				title
				createdAt
				feedType
				subtitle
				createdByUserId
				extraData
				feedSeen
				count
				completed
				important
			}
			id
			firstName
			lastName
			phoneNumber
			organizationUsers {
				id
				organizationId
				organization {
					organizationsOrderIntegrations {
						requestStatus
						deliveryDate
					}
				}
			}
		}
	}
`;

const HeaderWrapper = styled(Box)(
	({ theme }) => `
		display: flex;
		align-items: center;
        height: ${theme.header.height};
        color: ${theme.header.textColor};
        padding: ${theme.spacing(0, 1)};        
        margin: ${theme.spacing(1)};
        margin-top: ${theme.spacing(1.5)};        
        right: 0;
        z-index: 5;
        background-color: ${theme.header.background};
        box-shadow: ${theme.header.boxShadow};
        position: fixed;
        justify-content: space-between;
        width: calc(100% - ${theme.spacing(2)});
        border-radius: ${theme.shape.borderRadius}px;
`
);
function Header() {
	const {tokenParsed} = useKeycloak();
	const [value] = useNotifyer();
	const router = useRouter();
	const {state, time} = useAppState("active");
	const [showUserLookup, setShowUserLookup] = useState(false);

	const [updateLastSeenMutation] = useMutation(UPDATE_LASTSEEN_MUTATION);

	const { data: personalData, loading: personalLoading } = useSubscription(PERSONAL_DATA, {
		variables: { id: tokenParsed?.sub }
	});

	useEffect(() => {
		//console.log("updateLastSeen", state);
		if (state === "active") {
			updateLastSeenMutation({
				variables: {
					userId: tokenParsed?.sub,
					lastSeen: new Date().toISOString()
				}
			}).catch((e) => console.log("updateLastSeen fail: ", e));
		}
	}, [state]);

	const askForPermissionToReceiveNotifications = async() => {
		if (!("Notification" in window)) {
			console.log("This browser does not support notifications.");
		}
		else if ( Notification.permission === "granted") {
			console.log("Permission granted");
		}
		else if (Notification.permission !== "denied") {
			const permission = await Notification.requestPermission();
			if (permission === "granted") {
				console.log("wd Permission granted");
			}
		}
	};

	useEffect(() => {
		askForPermissionToReceiveNotifications();
	}, []);

	const userStates = personalData?.user?.states?.find((item) => item.type === "TELEPHONY");
	const phoneState = personalData?.user?.phoneState;

	useEffect(() => {
		if (userStates) {
			if (["ALERT", "BUSY"].includes(phoneState)) {
				setShowUserLookup(true);
			}
			else if (phoneState === "IDLE" && showUserLookup) {
				// keep open until 2 minutes after call ended or lostcall
				const t = setTimeout(() => {
					setShowUserLookup(false);
					console.log("timeoutistriggered");
				}, 60000);
				console.log("SET TIMEOUT: ", t);
				return () => clearTimeout(t);
			}
		}
		else {
			setShowUserLookup(false);
		}
	}, [phoneState]);

	return (
		<HeaderWrapper id={"HeaderWrapper"}>
			<Box sx={{display: "flex", alignItems: "center"}}>
				<LogoButton />
				{/*<HeaderSearchTextField />*/}
			</Box>
			{showUserLookup ? (
			 // {true ? (
				<UserLookUpComponent
					setShowUserLookup={setShowUserLookup}
					queueItemId={userStates?.queueItemId}
					domainUserData={userStates?.domainUser}
					phoneNumber={userStates?.value}
					phoneState={phoneState}
					domainActivity={userStates?.queueItem?.domainActivity}
				/>
			) : (
				<Box sx={{display: "hidden"}}/>
			)}
			<Box display="flex" alignItems="center">
				<IconButton onClick={() => { router.push("/"); }}>
					<FontAwesomeIcon
						icon={faHome}
						size={"sm"}
						color={"#6e6e6e"}
					/>
				</IconButton>
				<NotificationBell/>
				<HeaderUserbox />
				<MainMenu />
			</Box>
		</HeaderWrapper>
	);
}

export default Header;
